import Vue from 'vue'
import VueAxios from 'vue-axios'
import axios from 'axios'
Vue.use(VueAxios, axios)

const contentful = require('contentful')
const client = contentful.createClient({
  space: process.env.VUE_APP_CONTENTFUL_SPACE_NAME,
  accessToken: process.env.VUE_APP_CONTENTFUL_ACCESS_TOKEN
})

const sensataEndpoint = process.env.VUE_APP_SURVEY_DATA_ENDPOINT

export default {
  fetchSite ({ siteId }) {
    return new Promise((resolve, reject) => {
      return client
        .getEntry(siteId)
        .then(entry => {
          resolve(entry.fields)
        })
        .catch(err => {
          console.log(err)
          reject(err)
        })
    })
  },
  fetchSurvey ({ surveyId }) {
    return new Promise((resolve, reject) => {
      return client
        .getEntry(surveyId)
        .then(entry => {
          resolve(entry.fields)
        })
        .catch(err => {
          console.log(err)
          reject(err)
        })
    })
  },
  fetchTestResults ({ testResultsId }) {
    return new Promise((resolve, reject) => {
      return client
        .getEntry(testResultsId)
        .then(entry => {
          resolve(entry.fields)
        })
        .catch(err => {
          console.log(err)
          reject(err)
        })
    })
  },
  fetchProfile ({ profileId }) {
    return new Promise((resolve, reject) => {
      return client
        .getEntry(profileId)
        .then(entry => {
          resolve(entry)
        })
        .catch(err => {
          console.log(err)
          reject(err)
        })
    })
  },
  fetchQuestion ({ something }) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (Math.random() > 0.95) {
          reject({ code: 500 })
        }
        resolve(something)
      }, 1000)
    })
  },
  sendResponse ({ responses, surveyData }) {
    return new Promise((resolve, reject) => {
      var browserName = surveyData.browserReport.os ? surveyData.browserReport.os.name : 'undefined'
      var browserVersion = surveyData.browserReport.os ? surveyData.browserReport.os.version : 'undefined'
      var browserViewportWidth = surveyData.browserReport.viewport ? surveyData.browserReport.viewport.width : 'xx'
      var browserViewportHeight = surveyData.browserReport.viewport ? surveyData.browserReport.viewport.height : 'xx'

      return Vue.axios.post(sensataEndpoint, {
        browserOverview: `${surveyData.browserReport.ip} - ${browserName}/${browserVersion} - ${browserViewportWidth}x${browserViewportHeight}`,
        surveyName: surveyData.surveyName,
        surveyId: surveyData.surveyId,
        surveyData: surveyData,
        responses: responses
      })
        .then(data => {
          resolve(data)
        })
        .catch(err => {
          console.log('error: ', err)
          reject(err)
        })
    })
  }
}
